import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { SearchQuery, SearchResultSet } from '@backstage/plugin-search-common';
import { SearchApi } from '@backstage/plugin-search-react';
import qs from 'qs';

/**
 * Options used to construct a {@link SearchClient}.
 */
export interface SearchClientOptions {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
}

/**
 * Frontend client for the Backstage search backend.
 *
 * This mirrors the default implementation that ships with
 * `@backstage/plugin-search`. It is provided locally so Docs V2 search keeps
 * working without depending on the full search UI plugin.
 */
export class SearchClient implements SearchApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: SearchClientOptions) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async query(query: SearchQuery): Promise<SearchResultSet> {
    const queryString = qs.stringify(query);
    const baseUrl = await this.discoveryApi.getBaseUrl('search');
    const response = await this.fetchApi.fetch(
      `${baseUrl}/query?${queryString}`,
    );

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }

    return response.json();
  }
}
